import { ScaleManager } from "./ScaleManager";

export class SceneManager{

    static changeScene(origin:Phaser.Scene,targetScene:Phaser.Scene){

        if(origin.scene.manager.keys[targetScene.sys.settings.key]==undefined){
            delete origin.scene.manager.keys[targetScene.sys.settings.key];
        }
        let newScene = origin.scene.add(targetScene.sys.settings.key,targetScene,true);
        
        //origin.scene.manager.start(targetScene.sys.settings.key);
        
        origin.scene.manager.remove(origin.sys.settings.key);
        //delete origin.scene.manager.keys[origin.sys.settings.key];
        //targetScene.sys.settings.visible = false;
        //targetScene.sys.settings.visible = true;
        //(<Phaser.Scene>newScene).sys.events.on('start',(<ScaleManager>ScaleManager.Instance).Rescale,this);
        console.log(`Change Scene from: ${origin.sys.settings.key} to ${targetScene.sys.settings.key}`);
    }
}